import CONFIG from "Config";
export const AUTH_CONFIG = CONFIG.auth;
